import { CorePressable } from '@/components/Theme/Core/CorePressable';
import { withStyles } from '@/components/Theme/Core/withStyles';
import { motify } from 'moti';

export const MotiPressable = withStyles(motify(CorePressable)(), {noSwitch: true})